import { EType } from '../repositories/journal/entities/journal/GetJournalMoreDataSchema';

export const PostTypeUrls: { [key in EType]: string } = {
  [EType.Articles]: '/magazine/',
  [EType.Blogs]: '/blogs/',
  [EType.News]: '/novosti/',
  [EType.Questions]: '/forum-rieltorov/',
  [EType.Quizzes]: '/magazine/',
};

export const PostTypeNames: { [key in EType]: string } = {
  [EType.Articles]: 'Статьи',
  [EType.Blogs]: 'Блоги',
  [EType.News]: 'Новости',
  [EType.Questions]: 'Вопросы',
  [EType.Quizzes]: 'Опросы',
};
